import { render, staticRenderFns } from "./Offer.vue?vue&type=template&id=76b43168&"
import script from "./Offer.vue?vue&type=script&lang=js&"
export * from "./Offer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/36115602/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76b43168')) {
      api.createRecord('76b43168', component.options)
    } else {
      api.reload('76b43168', component.options)
    }
    module.hot.accept("./Offer.vue?vue&type=template&id=76b43168&", function () {
      api.rerender('76b43168', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/offerdetails/Offer.vue"
export default component.exports